
// import {  useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";

// import { List, ListItem, ListItemButton, ListItemIcon, Box, Container, Divider, ListItemText, Typography, useTheme } from "@mui/material";
// import { Facebook, X, Instagram, WhatsApp } from "@mui/icons-material";
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import CallIcon from '@mui/icons-material/Call';

// import PageLang from "../../../config/page.languge"
// import { RootState } from "../../../redux/store";
// import { NAVIGATE_CITIZEN } from "../../../constant";

// const socialLinks = [
//     {
//         name: "Facebook",
//         url: "https://www.facebook.com/share/19V4YoFhvU/",
//         icon: (
//             <Facebook sx={{ fontSize: 27, width: 45, height: 45, borderRadius: "50%", bgcolor: "#1877F2", color: "white", p: 1 }} />
//         )
//     },
//     {
//         name: "Twitter",
//         url: "https://x.com/CMRF_MH?t=Ldnbet9_aBjTsHm0kpGw_g&s=08",
//         icon: (
//             <X sx={{ fontSize: 27, width: 45, height: 45, borderRadius: "50%", bgcolor: "black", color: "white", p: 1 }} />
//         )
//     },
//     {
//         name: "Instagram",
//         url: "https://www.instagram.com/cmrf_maharashtra?igsh=b2tqb3JlZ3B6ZXo=",
//         icon: (
//             <Instagram sx={{ fontSize: 27, width: 45, height: 45, borderRadius: "50%", background: "linear-gradient(45deg, #F58529, #DD2A7B, #8134AF, #515BD4)", color: "white", p: 1, }} />
//         ),
//     },
//     {
//         name: "WhatsApp",
//         url: "https://whatsapp.com/channel/0029Vb65auMCHDyoCtIB3W2O",
//         icon: (
//             <WhatsApp sx={{ fontSize: 27, width: 45, height: 45, borderRadius: "50%", bgcolor: "#25D366", color: "white", p: 1 }} />
//         )
//     }
// ];

// type TranslationKeys = "termsConditionTitle" | "privacyTitle" | "copyrightTitle" | "disclaimerTitle" | "hyperlinkTitle";
// type LanguageOptions = "english" | "marathi";

// const translations: Record<TranslationKeys, Record<LanguageOptions, string>> = {
//     termsConditionTitle: { english: "Terms and Conditions", marathi: "अटी व शर्ती" },
//     privacyTitle: { english: "Privacy Policy", marathi: "गोपनीयता धोरण" },
//     copyrightTitle: { english: "Copyright Policy", marathi: "कॉपीराइट धोरण" },
//     disclaimerTitle: { english: "Disclaimer and Policies", marathi: "अस्वीकरण व धोरणे" },
//     hyperlinkTitle: { english: "Hyperlink Policy", marathi: "हायपरलिंकिंग धोरण" },
// };

// const innerPages: { key: TranslationKeys; path: string }[] = [
//     { key: "termsConditionTitle", path: NAVIGATE_CITIZEN.TERMS_CONDITIONS },
//     { key: "privacyTitle", path: NAVIGATE_CITIZEN.PRIVACY_POLICY },
//     { key: "copyrightTitle", path: NAVIGATE_CITIZEN.COPYRIGHT_POLICY },
//     { key: "disclaimerTitle", path: NAVIGATE_CITIZEN.DISCLAIMER },
//     { key: "hyperlinkTitle", path: NAVIGATE_CITIZEN.HYPERLINK_POLICY },
// ];

// const TOLL_FREE_NUMBER = "18001232211";
// const TOLL_FREE_TEL_LINK = `tel:${TOLL_FREE_NUMBER}`;

// const Footer = () => {
//     const theme = useTheme()
//     const language = useSelector((state: RootState) => state.language.language);
//     const navigate = useNavigate();

//     return (
//         <Box sx={{ backgroundColor: theme.palette.primary.main, color: '#fff', padding: '15px 0', textAlign: 'center', mt: 2 }}>
//             <Container>
//                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <List sx={{ width: { xs: '12%', sm: '4%' }, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, }}>
//                         {socialLinks.map((social, index) => (
//                             <ListItem key={index + 'social'} disablePadding>
//                                 <ListItemButton component="a" href={social.url} target="_blank" rel="noopener noreferrer">
//                                     <ListItemIcon>{social.icon}</ListItemIcon>
//                                 </ListItemButton>
//                             </ListItem>
//                         ))}
//                     </List>
//                 </Box>
//                 <Box sx={{ display: { xs: 'block', sm: 'flex' }, alignItems: 'center', justifyContent: 'center', m: 1 }}>
//                     <Typography variant="body2" display={'flex'} alignItems={'center'} mr={1} sx={{ mb: { xs: 2, sm: 0 }, fontSize: { xs: "0.8rem", md: "1rem" } }}><LocationOnIcon sx={{ mr: 1 }} /> {PageLang?.Address[language]} </Typography>
//                     <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', sm: 'block' }, mx: 2, width: 2, height: "25px", bgcolor: "background.paper" }} />

//                     <Typography variant="body2" display={'flex'} alignItems={'center'} mr={1} sx={{ mb: { xs: 2, sm: 0 }, fontSize: { xs: "0.8rem", md: "1rem" } }}> <CallIcon sx={{ mx: 1 }} />
//                         <a href={TOLL_FREE_TEL_LINK} style={{ color: "white", textDecoration: "none" }} >
//                             {PageLang?.TollFreeNumber[language]}
//                         </a>
//                     </Typography>

//                 </Box>
//                 <Box>
//                     <List
//                         sx={{
//                             display: 'flex',
//                             justifyContent: 'center',
//                             flexWrap: { xs: 'wrap', sm: 'nowrap' },
//                             padding: 0,
//                         }}
//                     >
//                         {innerPages.map((page, idx) => (
//                             <ListItem
//                                 key={page.key}
//                                 disablePadding
//                                 sx={{ width: 'auto', display: 'flex', alignItems: 'center' }}
//                             >
//                                 <ListItemButton onClick={() => navigate(page.path)} sx={{ color: 'white', '&:hover': { color: 'inherit', backgroundColor: 'transparent', }, padding: '8px 12px', borderRadius: 1, }} >
//                                     <ListItemText
//                                         primary={translations[page.key]?.[language] ?? page.key}
//                                         primaryTypographyProps={{ variant: 'body1', noWrap: true }}
//                                     />
//                                 </ListItemButton>
//                                 {idx < innerPages.length - 1 && (
//                                     <Typography component="span" sx={{ color: 'primary.contrastText', mx: 1, userSelect: 'none', }} >
//                                         |
//                                     </Typography>
//                                 )}
//                             </ListItem>
//                         ))}
//                     </List>
//                 </Box>
//             </Container>
//             <Typography variant="body2" sx={{ borderTop: '1px solid #ddd', pt: 2, px: 1, fontSize: { xs: "0.8rem", md: "1rem" } }}> {PageLang?.Govtright[language]} </Typography>
//         </Box>
//     )
// }
// export default Footer

import {
    Box,
    Container,
    ListItemText,
    Typography,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    Grid,
    Stack,
} from "@mui/material";
import { useSelector } from "react-redux";
import { Facebook, X, Instagram, Email, Phone, LocationOn, ArrowForward, WhatsApp } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { RootState } from "../../../redux/store";
import useResponsive from "../../../hooks/useResponsive";
import PageLang from "../../../config/page.languge";
import { NAVIGATE_CITIZEN } from "../../../constant";
import ImageWithLoader from "../../../components/common/ImageWithLoader";

const socialLinks = [
    {
        name: "Facebook",
        url: "https://www.facebook.com/share/19V4YoFhvU/",
        icon: (
            <Facebook sx={{ fontSize: 27, width: 45, height: 45, borderRadius: "50%", bgcolor: "#1877F2", color: "white", p: 1 }} />
        )
    },
    {
        name: "Twitter",
        url: "https://x.com/CMRF_MH?t=Ldnbet9_aBjTsHm0kpGw_g&s=08",
        icon: (
            <X sx={{ fontSize: 27, width: 45, height: 45, borderRadius: "50%", bgcolor: "black", color: "white", p: 1 }} />
        )
    },
    {
        name: "Instagram",
        url: "https://www.instagram.com/cmrf_maharashtra?igsh=b2tqb3JlZ3B6ZXo=",
        icon: (
            <Instagram sx={{ fontSize: 27, width: 45, height: 45, borderRadius: "50%", background: "linear-gradient(45deg, #F58529, #DD2A7B, #8134AF, #515BD4)", color: "white", p: 1, }} />
        ),
    },
    {
        name: "WhatsApp",
        url: "https://whatsapp.com/channel/0029Vb65auMCHDyoCtIB3W2O",
        icon: (
            <WhatsApp sx={{ fontSize: 27, width: 45, height: 45, borderRadius: "50%", bgcolor: "#25D366", color: "white", p: 1 }} />
        )
    }
];


type TranslationKeys = "termsConditionTitle" | "privacyTitle" | "copyrightTitle" | "disclaimerTitle" | "hyperlinkTitle" | "homeTitle";
type LanguageOptions = "english" | "marathi";

const translations: Record<TranslationKeys, Record<LanguageOptions, string>> = {
    homeTitle: { english: "Home", marathi: "मुख्यपृष्ठ" },
    termsConditionTitle: { english: "Terms and Conditions", marathi: "अटी व शर्ती" },
    privacyTitle: { english: "Privacy Policy", marathi: "गोपनीयता धोरण" },
    copyrightTitle: { english: "Copyright Policy", marathi: "कॉपीराइट धोरण" },
    disclaimerTitle: { english: "Disclaimer", marathi: "अस्वीकरण" },
    hyperlinkTitle: { english: "Hyperlink Policy", marathi: "हायपरलिंकिंग धोरण" },
};

const innerPages: { key: TranslationKeys; path: string }[] = [
    { key: "homeTitle", path: NAVIGATE_CITIZEN.HOME },
    { key: "termsConditionTitle", path: NAVIGATE_CITIZEN.TERMS_CONDITIONS },
    { key: "privacyTitle", path: NAVIGATE_CITIZEN.PRIVACY_POLICY },
    { key: "copyrightTitle", path: NAVIGATE_CITIZEN.COPYRIGHT_POLICY },
    { key: "disclaimerTitle", path: NAVIGATE_CITIZEN.DISCLAIMER },
    { key: "hyperlinkTitle", path: NAVIGATE_CITIZEN.HYPERLINK_POLICY },
];

const Footer = () => {
    const lang = useSelector((state: RootState) => state.language.language as LanguageOptions);
    const { isMobile } = useResponsive()
    const navigate = useNavigate()
    const year = new Date().getFullYear();
    const footerText = PageLang.Govtright[lang].replace("YEAR", year.toString());
    return (
        <Box component="footer" sx={{ background: "linear-gradient(135deg,rgb(1, 18, 26) 0%,rgb(6, 46, 65) 50%,rgb(3, 21, 31) 100%)", color: '#fff', position: 'relative', overflow: 'hidden', '&::before': { content: '""', position: 'absolute', top: 0, left: 0, right: 0, height: '6px', background: 'linear-gradient(90deg, #F34915 0%, #FF6B35 50%, #F34915 100%)', boxShadow: '0 2px 10px rgba(243, 73, 21, 0.5)', } }} >
            <Box sx={{ position: 'absolute', top: '-100px', right: '-100px', width: '300px', height: '300px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,255,255,0.05) 0%, transparent 70%)', pointerEvents: 'none', }} />
            <Box sx={{ position: 'absolute', bottom: '-150px', left: '-100px', width: '400px', height: '400px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(243, 73, 21, 0.1) 0%, transparent 70%)', pointerEvents: 'none', }} />
            <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
                <Box sx={{ py: { xs: 2, md: 4 } }}>
                    <Grid container spacing={{ xs: 2, md: 4 }}>
                        <Grid item xs={6} sm={6} md={4}>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                <Box
                                    sx={{
                                        width: isMobile ? 80 : 150,
                                        height: isMobile ? 80 : 150,
                                        borderRadius: 3,
                                        overflow: "hidden",
                                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                                        bgcolor: "white",
                                        display: "flex",p:1,
                                        alignItems: "center",
                                        justifyContent: "center",
                                        transition: "transform 0.3s ease",
                                        "&:hover": {
                                            transform: "scale(1.04)",
                                        },
                                    }}
                                    onClick={() => navigate(NAVIGATE_CITIZEN.HOME)}
                                >
                                    <ImageWithLoader
                                        src="/rugna-mitra/logo-main.jpeg"
                                        alt="Chief Minister Non-Governmental MoU Management Logo"
                                        style={{ width: "100%", height: "100%", objectFit: "contain", cursor: "pointer" }}
                                    />
                                </Box>

                                {/* TITLE */}
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 800,
                                        fontSize: { xs: "18px", md: "26px" },
                                        lineHeight: 1.3,
                                        color: "#ffffff",
                                        textShadow: "0px 2px 8px rgba(0,0,0,0.3)",
                                    }}
                                >
                                    {PageLang?.projectTitle[lang]}
                                </Typography>

                                {/* SUB TITLE */}
                                <Typography
                                    variant="body1"
                                    sx={{
                                        opacity: 0.9,
                                        color: "#f1f1f1",
                                        lineHeight: 1.8,
                                        mb: 2,
                                        fontSize: "0.95rem",
                                        maxWidth: "95%",
                                    }}
                                >
                                    {PageLang?.projectSubtitle[lang]}
                                </Typography>


                            </Box>
                        </Grid>
                        {/* <Grid item xs={12} sm={12} md={2} /> */}
                            {/* <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 700,
                                    mb: 1,
                                    fontSize: { xs: '16px', md: '18px' },
                                    position: 'relative',
                                    paddingBottom: '12px',
                                    '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        bottom: 0,
                                        left: 0,
                                        width: '50px',
                                        height: '3px',
                                        background: '#F34915',
                                        borderRadius: '2px',
                                    }
                                }}
                            >
                                {lang === "english" ? "Important" : "महत्त्वाचे"}
                            </Typography>

                            <List sx={{ p: 0 }}>
                                {[
                                    { label: lang === "english" ? "Home" : "मुख्यपृष्ठ", path: "/#register" },
                                    { label: lang === "english" ? "About Us" : "आमच्याबद्दल", path: "/#register" },
                                    { label: lang === "english" ? "Register Now" : "नोंदणी करा", key: "/#register", path: '/#register' },
                                    { label: lang === "english" ? "News & Update" : "ताज्या घडामोडी", path: "/#register" },
                                    { label: lang === "english" ? "Help" : "मदत", path: "/help" },
                                ].map((link, index) => (
                                    <ListItem key={index + ''} disablePadding>
                                        <ListItemButton
                                            onClick={(e) => {
                                                if (link.key) {
                                                    e.preventDefault();
                                                    const element = document.getElementById('register');
                                                    if (element) {
                                                        element.scrollIntoView({ behavior: "smooth" });
                                                    }
                                                    navigate(link.path);
                                                } else {
                                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                                    navigate(link.path);
                                                }
                                            }}
                                            sx={{
                                                color: 'rgba(255, 255, 255, 0.85)',
                                                borderRadius: '8px',
                                                transition: 'all 0.3s ease',
                                                px: 1.5,
                                                py: 1,
                                                '&:hover': {
                                                    color: '#fff',
                                                    background: 'rgba(255, 255, 255, 0.1)',
                                                    paddingLeft: '20px',
                                                    '& .MuiListItemIcon-root': { opacity: 1 }
                                                }
                                            }}
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    minWidth: '30px',
                                                    opacity: 0,
                                                    transition: 'opacity 0.3s ease'
                                                }}
                                            >
                                                <ArrowForward sx={{ fontSize: '16px', color: '#F34915' }} />
                                            </ListItemIcon>

                                            <ListItemText
                                                primary={link.label}
                                                primaryTypographyProps={{
                                                    fontSize: '14px',
                                                    fontWeight: 500
                                                }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List> */}

                        {/* </Grid> */}
                        <Grid item xs={6} sm={6} md={3}>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 700,
                                    mb: 1,
                                    fontSize: { xs: '16px', md: '18px' },
                                    position: 'relative',
                                    paddingBottom: '12px',
                                    '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        bottom: 0,
                                        left: 0,
                                        width: '50px',
                                        height: '3px',
                                        background: '#F34915',
                                        borderRadius: '2px',
                                    }
                                }}
                            >
                                {lang === "english" ? "Quick Links" : "द्रुत दुवे"}
                            </Typography>

                            <List sx={{ p: 0 }}>
                                {innerPages.map((page, index) => (
                                    <ListItem
                                        key={index + ''}
                                        disablePadding
                                    >
                                        <ListItemButton
                                            component={Link}
                                            to={page.path}
                                            onClick={(e) => {
                                                window.scrollTo({ top: 0, behavior: "smooth" });
                                            }}
                                            sx={{
                                                color: 'rgba(255, 255, 255, 0.85)',
                                                borderRadius: '8px',
                                                transition: 'all 0.3s ease',
                                                px: 1.5,
                                                py: 1,
                                                '&:hover': {
                                                    color: '#fff',
                                                    background: 'rgba(255, 255, 255, 0.1)',
                                                    paddingLeft: '20px',
                                                    '& .MuiListItemIcon-root': {
                                                        opacity: 1,
                                                    }
                                                },
                                            }}
                                        >
                                            <ListItemIcon sx={{
                                                minWidth: '30px',
                                                opacity: 0,
                                                transition: 'opacity 0.3s ease',
                                            }}>
                                                <ArrowForward sx={{ fontSize: '16px', color: '#F34915' }} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={translations[page.key]?.[lang]}
                                                primaryTypographyProps={{
                                                    fontSize: '14px',
                                                    fontWeight: 500,
                                                }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>
                        <Grid item xs={12} sm={6} md={5}>
                            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: '16px', md: '18px' }, position: 'relative', paddingBottom: '12px', '&::after': { content: '""', position: 'absolute', bottom: 0, left: 0, width: '50px', height: '3px', background: '#F34915', borderRadius: '2px', } }} >
                                {lang === "english" ? "Contact Us" : "संपर्क करा"}
                            </Typography>

                            <Stack spacing={1}>
                                {/* Address */}
                                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                    <Box
                                        sx={{
                                            minWidth: '40px',
                                            height: '40px',
                                            borderRadius: '10px',
                                            background: 'rgba(243, 73, 21, 0.15)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mr: 2,
                                        }}
                                    >
                                        <LocationOn sx={{ color: '#F34915', fontSize: '20px' }} />
                                    </Box>
                                    <Box>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                opacity: 0.9,
                                                lineHeight: 1.7,
                                                fontSize: '14px',
                                            }}
                                        >
                                            {PageLang?.Address[lang]}
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Phone */}
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box
                                        sx={{
                                            minWidth: '40px',
                                            height: '40px',
                                            borderRadius: '10px',
                                            background: 'rgba(243, 73, 21, 0.15)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mr: 2,
                                        }}
                                    >
                                        <Phone sx={{ color: '#F34915', fontSize: '20px' }} />
                                    </Box>
                                    <Box>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: '14px',
                                            }}
                                        >

                                            {PageLang?.TollFreeNumber[lang]}
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Email */}
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box
                                        sx={{
                                            minWidth: '40px',
                                            height: '40px',
                                            borderRadius: '10px',
                                            background: 'rgba(243, 73, 21, 0.15)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mr: 2,
                                        }}
                                    >
                                        <Email sx={{ color: '#F34915', fontSize: '20px' }} />
                                    </Box>
                                    <Box>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontSize: '14px',
                                                wordBreak: 'break-word',
                                            }}
                                        >
                                            osd.cmrf@maharashtra.gov.in
                                        </Typography>
                                    </Box>
                                </Box>
                            </Stack>
                            {/* CONTACT TITLE */}
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: "15px",
                                    textTransform: "uppercase",
                                    letterSpacing: "1.5px",
                                    color: "#FBE9E7",
                                    mb: 1,
                                    mt: 2
                                }}
                            >
                                {lang === "english" ? "Get in Touch" : "आमच्याशी संपर्क साधा"}
                            </Typography>

                            {/* SOCIAL ICONS */}
                            <Stack direction="row" spacing={2}>
                                {socialLinks.map((social, index) => (
                                    <Box
                                        key={index}
                                        component="a"
                                        href={social.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                            width: 48,
                                            height: 48,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            borderRadius: "50%",
                                            background: "rgba(255, 255, 255, 0.08)",
                                            backdropFilter: "blur(14px)",
                                            border: "1px solid rgba(255, 255, 255, 0.15)",
                                            color: "#fff",
                                            transition: "0.35s ease",
                                            "&:hover": {
                                                background: "#ff5722",
                                                transform: "translateY(-4px) scale(1.08)",
                                                boxShadow: "0 8px 25px rgba(255, 87, 34, 0.4)",
                                                borderColor: "#ff5722",
                                            },
                                            svg: {
                                                fontSize: "1.35rem",
                                            }
                                        }}
                                    >
                                        {social.icon}
                                    </Box>
                                ))}
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)', py: 2, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'center', alignItems: 'center', gap: 2, }} >
                    <Typography
                        variant="body2"
                        sx={{
                            opacity: 0.85,
                            fontSize: '14px',
                            textAlign: { xs: 'center', md: 'left' },
                        }}
                    >
                        {footerText}
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;